import React, { useState } from "react";
import { Table, Select, Button, Input, List } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import styles from "./StaffMaterialManagement.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { InputField, SearchInput, TextComponent } from "../../../../../components";
import { SubmitButton } from "../../../../../components";
import { ReactComponent as DeleteIcon } from "../../../../../assets/images/deleteIcon.svg";
import { ReactComponent as EditIcon } from "../../../../../assets/images/editIcon.svg";
import { ReactComponent as MinusIcon } from "../../../../../assets/images/minusIcon.svg";
import { ReactComponent as PlusIcon } from "../../../../../assets/images/plusIcon.svg";
import ModalLeft from "../../../../../components/ModalLeft/ModalLeft";
import HeaderComponent from "../../../../../components/HeaderComponent/HeaderComponent";

const  MaterialManagement = () => {
    const [AdjustStockModal, setAdjustStockModal] = useState(false);
    const [quantity, setquantity] = useState(2);
    const [vendor, setvendor] = useState('');
    const [reason, setreason] = useState('');
    const [cost, setcost] = useState(2);
    const navigate = useNavigate();
    const location = useLocation();
    const formData = location?.state || {};

    // console.log('Received form data:', formData);

    const columns = [
        {
            title: "Lot No",
            dataIndex: "LotNo",
            key: "No",
        },
        {
            title: "Order Date",
            dataIndex: "OrderDate",
            key: "OrderDate",
        },
        {
            title: "Vendor",
            key: "Vendor",
            dataIndex: "Vendor",
        },
        {
            title: "Lot size",
            key: "LotSize",
            dataIndex: "LotSize",
        },
        {
            title: "Lot Used",
            key: "LotUsed",
            dataIndex: "LotUsed",
        },
        
    ];

    const data = [
        {
            LotNo: "#123",
            OrderDate: "Aug 13, 2025 ",
            Vendor: "Golden Harvest Supplies",
            LotSize: "50 kg",
            LotUsed: "30 kg",
         },
        {
            LotNo: "#123",
            OrderDate: "Aug 8, 2025 ",
            Vendor: "Pack Sure Solutions",
            LotSize: "10 kg",
            LotUsed: "30 kg",
         },
        {
            LotNo: "#123",
            OrderDate: "Aug 6, 2025  ",
            Vendor: "PureGrain Ingredients Co",
            LotSize: "30 kg",
            LotUsed: "05 kg",
         },
        {
            LotNo: "#123",
            OrderDate: "Aug 11, 2025 ",
            Vendor: "Eco Wrap Packaging Co. ",
            LotSize: "20 kg",
            LotUsed: "15 kg",
         },
        {
            LotNo: "#123",
            OrderDate: "Aug 9, 2025 ",
            Vendor: "Secure Seal Supplies",
            LotSize: "10 kg",
            LotUsed: "05 kg",
         },

    ];

    const detailData = [
        {
            id: 1,
            label: "Unit of Measure",
            value: "lbs",
        },
        {
            id: 2,
            label: "Current Stock Level",
            value: "02",
        },
        {
            id: 3,
            label: "Categories",
            value: "Flour",
        },
        // {
        //     id: 4,
        //     label: "Allergen",
        //     value: "Nut",
        // },
        {
            id: 5,
            label: "Low Stock Threshold",
            value: "0.5",
        },
        {
            id: 6,
            label: "Notes",
            value: "e.g., storage instructions",
        }, 
        // {
        //     id: 7,
        //     label: "Shelf-life (Day)",
        //     value: "180",
        // },

    ]

    return (
        <div className={styles.mainCont}>
            <HeaderComponent
                heading="Cake Boards"
                // heading={formData?.Ingredient_Name}
                showBackIcon={true}
                  rightControlsStyle={styles.rightControlsStyle}
            // showControlButtons={true}
            // onDelete={() => console.log('Deleted')}
            // onEdit={() => console.log('Deleted')}
            />

            <div className={styles.itemsContDiv}>
                <List
                    grid={{
                        gutter: 16,
                        xs: 1,
                        sm: 2,
                        md: 3,
                        lg: 3,
                        xl: 3,
                        xxl: 4,
                    }}
                    dataSource={detailData}
                    renderItem={(item) => (
                        <List.Item>
                            <div className={styles.infoItem}>
                                <span className={styles.itemLabel}>{item.label}:</span>
                                <span className={styles.itemValue}>{item.value}</span>
                            </div>
                        </List.Item>
                    )}
                />
            </div>
            <div>
                <TextComponent className={styles.Heading} text={"Receiving  History"} />
            </div>

            {/* Table Section */}
            <div className={styles.subCont}>
                <div className={styles.TableDiv}>
                    <Table
                        scroll={{ x: true }}
                        columns={columns}
                        dataSource={data}
                        pagination={false}
                        rowKey="No"
                    />
                </div>
            </div>
            <ModalLeft
                open={AdjustStockModal}
                onCancel={() => setAdjustStockModal(false)}
                className={styles.modalCont}
                title={"Adjust Stock"}
                buttonTitle={"Adjust Stock"}
                onBtnPress={() => setAdjustStockModal(false)}
                btnStyle={{ marginTop: '20px', width: '50%' }}
            >
                <div className={styles.modalContent}>
                    <TextComponent className={styles.itemName} text={formData?.Ingredient_Name} />

                    <div className={styles.itemRow}>
                        <TextComponent className={styles.itemName} text={"Quantity Changed"} />
                        <div className={styles.itemControls}>
                            <MinusIcon className={styles.Controls} onClick={() => { quantity >= 1 && setquantity(quantity - 1) }} />
                            <TextComponent className={styles.ControlsText} text={quantity} />
                            <PlusIcon className={styles.Controls} onClick={() => setquantity(quantity + 1)} />
                        </div>
                    </div>
                    <div className={styles.itemRow}>
                        <TextComponent className={styles.itemName} text={"Vendor"} />
                        <div className={styles.search_div}>
                            <SearchInput
                                placeholder="Search..."
                                prefix={<SearchOutlined />}
                                className={styles.searchInput}
                                onChange={(e) => setvendor(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className={styles.itemRow}>
                        <TextComponent className={styles.itemName} text={"Adjustment Reason"} />
                        <div className={styles.search_div}>
                            <InputField
                                inputStyle={{
                                    backgroundColor: "var(--bg-grey)",
                                }}
                                innerInput={{
                                    backgroundColor: "var(--bg-grey)",
                                    color: "var(--black-color)",
                                }}
                                placeholder={"Restocked"}
                                value={reason}
                                onChange={(e) => setreason(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className={styles.itemRow}>
                        <TextComponent className={styles.itemName} text={"Cost"} />
                        <div className={styles.itemControls}>
                            <MinusIcon className={styles.Controls} onClick={() => { cost >= 1 && setcost(cost - 1) }} />
                            <TextComponent className={styles.ControlsText} text={`$ ${cost}`} />
                            <PlusIcon className={styles.Controls} onClick={() => setcost(cost + 1)} />
                        </div>
                    </div>
                </div>
            </ModalLeft>
        </div>
    );
};

export default  MaterialManagement;

